import React, { useEffect } from 'react';
import { EscrowAnalysisPage, i18n } from '@fmc-digital/servicing';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { auth, config } from '../../../config';
import { withHeaderFooter } from '../../HOCs/withHeaderFooter/withHeaderFooter';
import { ApiLogger } from 'fmc-digital-common';
import { logApiEvent, logUserEvent } from '@analytics/amplifyLogging';
import { AxiosRequestConfig } from 'axios';
import { v4 } from 'uuid';
import { EscrowNavigationProps } from '@components_v2/data/header-data';
import { useHomeContext } from '@components_v2/context/MyHomeContext';
import { useDispatch } from 'react-redux';
import { fetchStatementAsync } from '@store/actions/statements.action';

const EscrowAnalysis = () => {
    const dispatch = useDispatch();
    const { loanNumber } = useParams();
    const correlationId = v4();
    const { accountDetailSSO } = useHomeContext();
    const token = auth.isNotDefined ? null : auth.getOkta().getAccessToken();

    const requestConfig: AxiosRequestConfig = {
        method: 'get',
        url: `${config.env('escrowUrl')}${loanNumber}/details`,
        headers: {
            Authorization: `Bearer ${token}`,
            'x-correlation-id': correlationId,
            'x-api-key': config.env('xApiKey')
        }
    };
    const { data, isLoading } = useQuery({
        queryKey: ['fetch-escrow-details', loanNumber],
        queryFn: async () => ApiLogger(requestConfig, logApiEvent),
        enabled: !!loanNumber
    });
    const handlePayment = async () => {
        accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost?target_menu=oneTimePayment`);
    };

    const handleStatement = () => {
        dispatch(fetchStatementAsync.request(loanNumber, '2282'));
    };

    useEffect(() => {
        logUserEvent({
            action: 'EscrowAnalysisSummaryDisplayed',
            description: 'User Navigated to Escrow Analysis Summary Screen',
            type: 'EscrowAnalysisSummary'
        });
    }, []);

    return isLoading ? (
        <p>Loading</p>
    ) : (
        <EscrowAnalysisPage initValues={data} handleStatement={handleStatement} handlePayment={handlePayment} />
    );
};
export const EscrowAnalysisContainer = withHeaderFooter(EscrowAnalysis, {
    i18n,
    ...EscrowNavigationProps
});
